const releasesValidationFR = {
    "add": {
        "releaseName": {
            "required": 'Le nom de la sortie est requis',
            "length": 'Le nom de la sortie doit comporter plus de 2 caractères et moins de 120 caractères',
            "noForwardSlash": 'Le nom de la sortie ne doit pas contenir de barre oblique (/)',
            "matchTrack": 'Pour une sortie d\'une seule chanson, le nom de la sortie doit correspondre à la piste.',
            // validCharacters: 'Le nom de la sortie ne peut contenir que des lettres, des chiffres, des espaces et des underscores'
            },
            "releaseVersion": {
                "length": 'La version de la sortie doit comporter plus de 2 caractères et moins de 120 caractères',
                "validCharacters": 'La version de la sortie ne peut contenir que des lettres, des chiffres, des espaces et des underscores',
                "missingOne": 'Votre sortie ne contient qu\'une seule piste qui n\'est pas un Original Mix, par conséquent, le nom du mix personnalisé doit être inséré dans la version de la sortie.',
                "missingTwo": 'Si une sortie offre plus de contenu que la version standard ou s\'il s\'agit d\'une autre version d\'un album/sortie déjà publié, vous devez insérer la version de la sortie.',
                "invalid": 'Pour une sortie d\'une seule chanson sans nom de mix (Original Mix), la version de la sortie doit être laissée vide. Veuillez soit effacer la version de la sortie, soit ajouter un nom de mix à la chanson.'
            },
            "releaseLanguage": {
                "required": 'La langue de la sortie est requise. Veuillez sélectionner la langue de votre nom de sortie.'
            },
            "releaseEAN_UPC": {
                "required": "Le code EAN / UPC est requis.",
                "length": "Le numéro EAN doit comporter exactement 13 caractères.",
                "isValidEAN": "La valeur n'est pas un EAN valide. Si vous ajoutez une nouvelle sortie, veuillez entrer un EAN correct. Si vous importez un ancien catalogue et que l'EAN est invalide, veuillez nous contacter."
            },
            "releaseLabel": {
                "required": 'Veuillez sélectionner votre label.'
            },
            "releaseCopyright": {
                "required": 'Vous devez saisir le propriétaire du droit d\'auteur. Habituellement, c\'est votre label.'
            },
            "releaseCopyrightYear": {
                "required": 'Veuillez saisir l\'année de droit d\'auteur dans laquelle cette sortie sera (a été) publiée.',
                "regexp": 'Veuillez saisir une année de droit d\'auteur valide'
            },
            "releaseCopyrightPublisher": {
                "required": 'Vous devez saisir le propriétaire de l\'éditeur. Habituellement, c\'est votre label.'
            },
            "releaseCopyrightYearPublisher": {
                "required": 'Veuillez saisir l\'année de droit d\'auteur dans laquelle cette sortie sera (a été) publiée.',
                "regexp": 'Veuillez saisir une année de droit d\'auteur valide'
            },
            "releaseGenre": {
                "required": 'Veuillez sélectionner le genre de votre sortie.'
            },
            "releaseSubGenre": {
                "required": 'Veuillez sélectionner le sous-genre de votre sortie'
            },
            "releaseCatalogNumber": {
                "required": 'Insérez un numéro de catalogue de sortie unique.',
                "length": 'Minimum 4 et maximum 16 caractères.',
                "validFormat": 'Veuillez insérer votre numéro de catégorie sans espaces, uniquement des lettres MAJUSCULES et des chiffres. Les deux premiers caractères doivent être des lettres MAJUSCULES. MM001, MMD001, MM0001 ... '
            },
            "releaseDescription": {
                // required: 'Une bonne description de sortie professionnelle peut faire la différence.',
                "length": 'Une description de sortie doit comporter au moins 100 caractères et au maximum 600 caractères.'
            },
            "releaseArtwork": {
                "required": 'L\'illustration est requise',
                "wrongSpecsAndColor": 'Spécifications d\'image incorrectes et format de couleur incorrect. La taille de la couverture de la sortie doit être exactement de 3000 x 3000 px, couleurs RVB, JPG, taille de fichier max 4 Mo.',
                "wrongColorFormat": 'Format de couleur d\'image incorrect. La couverture de la sortie doit être en couleurs RVB. JPG, taille de fichier max 4 Mo.',
                "wrongSpecs": 'Spécifications d\'image incorrectes. La taille de la couverture de la sortie doit être exactement de 3000 x 3000 px. JPG, taille de fichier max 4 Mo.',
                "meetsSpecs": 'L\'image répond à toutes les spécifications.',
                "chooseImage": 'Veuillez choisir une image',
                "fileTooLarge": 'Le fichier sélectionné est plus grand que 4 Mo. Veuillez télécharger une couverture en 3000x3000 px, JPG, couleurs RVB, taille de fichier max 4 Mo',
                "wrongExtension": 'Extension de fichier incorrecte. Le fichier sélectionné a l\'extension ".jpeg". Veuillez télécharger une couverture en 3000x3000 px, JPG (extension ".jpg" uniquement), couleurs RVB, taille de fichier max 4 Mo'
            },
            "releaseTerritories": {
                "required": 'Veuillez sélectionner les territoires.'
            },
            "atleastOneCountrySelected": {
                "required": 'Veuillez sélectionner au moins un pays.'
            },
            "atleastOneContentIDChoiceSelected": {
                "required": 'La déclaration de l\'ID de contenu Youtube est obligatoire, veuillez sélectionner l\'une des options ci-dessus.'
            },
            "originalReleaseDate": {
                "required": 'Veuillez sélectionner la date de sortie originale pour tous les magasins dans le monde.'
            },
            "officialReleaseDate": {
                "required": 'Veuillez sélectionner la date de sortie officielle pour tous les magasins dans le monde.'
            },
            "atleastOneMainArtist": {
                "required": 'Au moins un artiste doit être principal'
            },
            "featuringArtistMissing": {
                "required": 'La sortie doit avoir l\'artiste en vedette listé dans le titre correctement assigné à un rôle d\'artiste en vedette. Veuillez corriger et soumettre à nouveau.'
            },
            "duplicateArtists": {
                "required": 'Il y a deux artistes ou plus avec le même nom.'
            },
            "artistName": {
                "required": 'Veuillez sélectionner un artiste'
            },
            "artistType": {
                "required": 'Veuillez sélectionner le type d\'artiste'
            },
            "trackName": {
                "required": 'Veuillez saisir le nom de la piste'
            },
            "trackMixName": {
                "required": 'Veuillez saisir le nom du mix',
                "regexp": 'Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores'
            }
    },
    "update": {
        "releaseName": {
            "required": 'Le nom de la sortie est requis',
            "length": 'Le nom de la sortie doit comporter plus de 2 caractères et moins de 120 caractères',
            "noForwardSlash": 'Le nom de la sortie ne doit pas contenir de barre oblique (/)',
            "matchTrack": 'Pour une sortie d\'une seule chanson, le nom de la sortie doit correspondre à la piste.',
            "validCharacters": 'Le nom de la sortie ne peut contenir que des lettres, des chiffres, des espaces et des underscores'
        },
        "releaseVersion": {
            "length": 'La version de la sortie doit comporter plus de 2 caractères et moins de 120 caractères',
            "validCharacters": 'La version de la sortie ne peut contenir que des lettres, des chiffres, des espaces et des underscores',
            "missingOne": 'Votre sortie ne contient qu\'une seule piste qui n\'est pas un Original Mix, par conséquent, le nom du mix personnalisé doit être inséré dans la version de la sortie.',
            "missingTwo": 'Si une sortie offre plus de contenu que la version standard ou s\'il s\'agit d\'une autre version d\'un album/sortie déjà publié, vous devez insérer la version de la sortie.',
            "invalid": 'Pour une sortie d\'une seule chanson sans nom de mix (Original Mix), la version de la sortie doit être laissée vide. Veuillez soit effacer la version de la sortie, soit ajouter un nom de mix à la chanson.'
        },
        "releaseLanguage": {
            "required": 'La langue de la sortie est requise. Veuillez sélectionner la langue de votre nom de sortie.'
        },
        "releaseEAN_UPC": {
            "required": "Le code EAN / UPC est requis.",
            "length": "Le numéro EAN doit comporter exactement 13 caractères.",
            "isValidEAN": "La valeur n'est pas un EAN valide. Si vous ajoutez une nouvelle sortie, veuillez entrer un EAN correct. Si vous importez un ancien catalogue et que l'EAN est invalide, veuillez nous contacter."
        },
        "releaseLabel": {
            "required": 'Veuillez sélectionner votre label.'
        },
        "releaseCopyright": {
            "required": 'Vous devez sélectionner le propriétaire du droit d\'auteur. Habituellement, c\'est votre label.'
        },
        "releaseCopyrightYear": {
            "required": 'Veuillez saisir l\'année de droit d\'auteur dans laquelle cette sortie sera (a été) publiée.',
            "regexp": 'Veuillez saisir une année de droit d\'auteur valide'
        },
        "releaseCopyrightPublisher": {
            "required": 'Vous devez saisir le propriétaire de l\'éditeur. Habituellement, c\'est votre label.'
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Veuillez saisir l\'année de droit d\'auteur dans laquelle cette sortie sera (a été) publiée.',
            "regexp": 'Veuillez saisir une année de droit d\'auteur valide'
        },
        "releaseGenre": {
            "required": 'Veuillez sélectionner le genre de votre sortie.'
        },
        "releaseSubGenre": {
            "required": 'Veuillez sélectionner le sous-genre de votre sortie'
        },
        "releaseCatalogNumber": {
            "required": 'Insérez un numéro de catalogue de sortie unique.',
            "length": 'Minimum 4 et maximum 16 caractères.',
            "validFormat": 'Veuillez insérer votre numéro de catégorie sans espaces, uniquement des lettres MAJUSCULES et des chiffres. Les deux premiers caractères doivent être des lettres MAJUSCULES. MM001, MMD001, MM0001 ...'
        },
        "releaseDescription": {
            "length": 'Une description de sortie doit comporter au moins 100 caractères et au maximum 600 caractères.'
        },
        "releaseArtwork": {
            "required": 'L\'illustration est requise',
            "wrongSpecsAndColor": 'Spécifications d\'image incorrectes et format de couleur incorrect. La taille de la couverture de la sortie doit être exactement de 3000 x 3000 px, couleurs RVB, JPG, taille de fichier max 4 Mo.',
            "wrongColorFormat": 'Format de couleur d\'image incorrect. La couverture de la sortie doit être en couleurs RVB. JPG, taille de fichier max 4 Mo.',
            "wrongSpecs": 'Spécifications d\'image incorrectes. La taille de la couverture de la sortie doit être exactement de 3000 x 3000 px. JPG, taille de fichier max 4 Mo.',
            "meetsSpecs": 'L\'image répond à toutes les spécifications.',
            "chooseImage": 'Veuillez choisir une image',
            "fileTooLarge": 'Le fichier sélectionné est plus grand que 4 Mo. Veuillez télécharger une couverture en 3000x3000 px, JPG, couleurs RVB, taille de fichier max 4 Mo',
            "wrongExtension": 'Extension de fichier incorrecte. Le fichier sélectionné a l\'extension ".jpeg". Veuillez télécharger une couverture en 3000x3000 px, JPG (extension ".jpg" uniquement), couleurs RVB, taille de fichier max 4 Mo'
        },
        "releaseTerritories": {
            "required": 'Veuillez sélectionner les territoires.'
        },
        "atleastOneCountrySelected": {
            "required": 'Veuillez sélectionner au moins un pays.'
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'La déclaration de l\'ID de contenu Youtube est obligatoire, veuillez sélectionner l\'une des options ci-dessus.'
        },
        "originalReleaseDate": {
            "required": 'Veuillez sélectionner la date de sortie originale pour tous les magasins dans le monde.'
        },
        "officialReleaseDate": {
            "required": 'Veuillez sélectionner la date de sortie officielle pour tous les magasins dans le monde.'
        },
        "atleastOneMainArtist": {
            "required": 'Au moins un artiste doit être principal'
        },
        "featuringArtistMissing": {
            "required": 'La sortie doit avoir l\'artiste en vedette listé dans le titre correctement assigné à un rôle d\'artiste en vedette. Veuillez corriger et soumettre à nouveau.'
        },
        "duplicateArtists": {
            "required": 'Il y a deux artistes ou plus avec le même nom.'
        },
        "artistName": {
            "required": 'Veuillez sélectionner un artiste'
        },
        "artistType": {
            "required": 'Veuillez sélectionner le type d\'artiste'
        },
        "trackName": {
            "required": 'Veuillez saisir le nom de la piste'
        },
        "trackMixName": {
            "required": 'Veuillez saisir le nom du mix',
            "regexp": 'Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores'
        }
    },
    "transfer": {
        "releaseName": {
            "required": "Le nom de la sortie est requis",
            "length": "Le nom de la sortie doit être entre 2 et 120 caractères",
            "invalid": "Le nom de la sortie ne peut pas contenir de barre oblique (/)"
        },
        "releaseVersion": {
            "length": "La version de la sortie doit comporter plus de 2 caractères et moins de 120 caractères",
            "regexp": "La version de la sortie ne peut contenir que des lettres, des chiffres, des espaces et des underscores",
            "missingOne": "Votre sortie ne contient qu'une seule piste qui n'est pas un Original Mix, par conséquent, le nom du mix personnalisé doit être inséré dans la version de la sortie.",
            "missingTwo": "Si une sortie offre plus de contenu que la version standard ou s'il s'agit d'une autre version d'un album/sortie déjà publié, vous devez insérer la version de la sortie.",
            "invalid": "Pour une sortie d'une seule chanson sans nom de mix (Original Mix), la version de la sortie doit être laissée vide. Veuillez soit effacer la version de la sortie, soit ajouter un nom de mix à la chanson."
        },
        "releaseLanguage": {
            "required": "La langue de la sortie est requise. Veuillez sélectionner la langue de votre nom de sortie."
        },
        "releaseLabel": {
            "required": "Veuillez sélectionner votre label."
        },
        "releaseCopyright": {
            "required": "Vous devez saisir le propriétaire du droit d'auteur. Habituellement, c'est votre label."
        },
        "releaseCopyrightYear": {
            "required": "Veuillez saisir l'année de droit d'auteur dans laquelle cette sortie sera (a été) publiée.",
            "regexp": "Veuillez saisir une année de droit d'auteur valide"
        },
        "releaseCopyrightPublisher": {
            "required": "Vous devez saisir le propriétaire de l'éditeur. Habituellement, c'est votre label."
        },
        "releaseCopyrightYearPublisher": {
            "required": "Veuillez saisir l'année de droit d'auteur dans laquelle cette sortie sera (a été) publiée.",
            "regexp": "Veuillez saisir une année de droit d'auteur valide"
        },
        "releaseGenre": {
            "required": "Veuillez sélectionner le genre de votre sortie."
        },
        "releaseSubGenre": {
            "required": "Veuillez sélectionner le sous-genre de votre sortie."
        },
        "releaseCatalogNumber": {
            "required": "Insérez un numéro de catalogue de sortie unique.",
            "length": "Minimum 4 et maximum 16 caractères.",
            "regexp": "Veuillez insérer votre numéro de catégorie sans espaces, uniquement des lettres MAJUSCULES et des chiffres. Les deux premiers caractères doivent être des lettres MAJUSCULES. MM001, MMD001, MM0001 ... "
        },
        "releaseDescription": {
            "length": "Une description de sortie doit comporter au moins 100 caractères et au maximum 600 caractères."
        },
        "releaseArtwork": {
            "required": "L'illustration est requise",
            "invalidDimensionsAndColorFormat": "Spécifications d'image incorrectes et format de couleur incorrect. La taille de la couverture de la sortie doit être exactement de 3000 x 3000 px, couleurs RVB, JPG, taille de fichier max 4 Mo.",
            "invalidColorFormat": "Format de couleur d'image incorrect. La couverture de la sortie doit être en couleurs RVB. JPG, taille de fichier max 4 Mo.",
            "invalidDimensions": "Spécifications d'image incorrectes. La taille de la couverture de la sortie doit être exactement de 3000 x 3000 px. JPG, taille de fichier max 4 Mo.",
            "valid": "L'image répond à toutes les spécifications",
            "choose": "Veuillez choisir une image",
            "fileSize": "Le fichier sélectionné est plus grand que 4 Mo. Veuillez télécharger une couverture en 3000x3000 px, JPG, couleurs RVB, taille de fichier max 4 Mo",
            "fileExtension": "Extension de fichier incorrecte. Le fichier sélectionné a l'extension '.jpeg'. Veuillez télécharger une couverture en 3000x3000 px, JPG (extension '.jpg' uniquement), couleurs RVB, taille de fichier max 4 Mo"
        },
        "releaseTerritories": {
            "required": "Veuillez sélectionner les territoires."
        },
        "atleastOneCountrySelected": {
            "required": "Veuillez sélectionner au moins un pays."
        },
        "atleastOneContentIDChoiceSelected": {
            "required": "La déclaration de l'ID de contenu Youtube est obligatoire, veuillez sélectionner l'une des options ci-dessus."
        },
        "originalReleaseDate": {
            "required": "Veuillez sélectionner la date de sortie originale pour tous les magasins dans le monde."
        },
        "officialReleaseDate": {
            "required": "Veuillez sélectionner la date de sortie officielle pour tous les magasins dans le monde."
        },
        "atleastOneMainArtist": {
            "required": "Au moins un artiste doit être principal"
        },
        "artistType": {
            "required": "Veuillez sélectionner le type d'artiste"
        },
        "trackName": {
            "required": "Veuillez saisir le nom de la piste"
        },
        "trackMixName": {
            "required": "Veuillez saisir le nom du mix",
            "regexp": "Le nom du mix ne peut contenir que des lettres, des chiffres, des espaces et des underscores"
        }
    }
};

export default releasesValidationFR;